import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from './components/layout/layout'
import Login from './pages/Auth/Login/Login' // Assuming your login page path
import AppRoutes from './routes/AppRoutes'
import ToastNotification from './components/ToastNotification/ToastNotification'
import '@mui/material/styles'
import ProtectedRoute from './components/ProtectedRoute'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'

function App() {
  return (
    <Router>
      <ToastNotification />
      <Tooltip
        id="table-tooltip"
        place="top"
        style={{
          backgroundColor: '#fb6514',
          color: '#fff',
          fontSize: '0.75rem',
          borderRadius: '4px',
          padding: '4px 8px',
          zIndex: 99999,
        }}
      />
      <Routes>
        {/* Public routes (no Layout) */}
        <Route path="/login" element={<Login />} />

        {/* Authenticated routes (with Layout) */}
        <Route element={<ProtectedRoute />}>
          <Route
            path="/*"
            element={
              <Layout>
                <AppRoutes />
              </Layout>
            }
          />
        </Route>
      </Routes>
    </Router>
  )
}

export default App
